import {
  createValidator,
  required,
  validateDateRange
} from '../../../../util/form/validation';

export const validation = createValidator({
  'serviceStopDate': [
    required('Please enter a valid date'),
    validateDateRange('The disconnect date')
  ]
});

export const fields = [
  'serviceStopDate'
];



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/cancel/cancelHelpers.js
 **/